module.exports = __webpack_public_path__ + "fonts/CeraPro-Medium.05c11104.woff2";